import { style } from 'typestyle'
export const mt4 = style({ marginTop: '4px' })
